import Vue from "vue";
import Router from "vue-router";

import main from "./main_routes";
import errorRoutes from "./error_routes";
import my_organization_routes from "./my_organization_routes";
import calc_routes from "./calc_routes";
import calc_register_routes from "./calc_register_routes";
import calc_register_manager_routes from "./calc_register_manager_routes";
import send_request_routes from "./send_request_routes";
import my_docs_routes from './my_documents_routes'

Vue.use(Router);

const uniqMenu = (menu) => {
  let result = new Array();
  const menuIds = new Array();
  for (const item of menu) {
    if (!menuIds.includes(item.id)) {
      result.push(item);
      menuIds.push(item.id);
    } else {
      result = result.filter((row) => row.id !== item.id);
      result.push(item);
      menuIds.push(item.id);
    }
  }
  return result;
};

const generateRoutes = (obj) => {
  const { routes, menu } = obj;
  const newRoutes = Array.from(new Set(routes));
  const newmenu = Array.from(new Set(menu)).sort((a, b) => a.id - b.id);

  return new Router({
    mode: "history",
    routes: newRoutes,
    menu: uniqMenu(newmenu),
  });
};

export default (role) => {
  const banned = {
    routes: [...main.routes, ...errorRoutes],
    menu: [...main.menu],
  };
  const users = {
    routes: [
      ...banned.routes,
      ...calc_routes.routes,
      ...my_docs_routes.routes,
      ...calc_register_routes.routes,
      ...send_request_routes.routes,
    ],
    menu: [
      ...banned.menu,
      ...calc_routes.menu,
      ...my_docs_routes.menu,
      ...calc_register_routes.menu,
      ...send_request_routes.menu,
    ],
  };

  const manager = {
    routes: [
      ...banned.routes,
      ...calc_routes.routes,
      ...my_docs_routes.routes,
      ...send_request_routes.routes,
      ...calc_register_manager_routes.routes,
      ...my_organization_routes.routes,
    ],
    menu: [
      ...banned.menu,
      ...calc_routes.menu,
      ...send_request_routes.menu,
      ...my_docs_routes.menu,
      ...calc_register_manager_routes.menu,
      ...my_organization_routes.menu,
    ],
  };

  const admin = {
    routes: [...manager.routes],
    menu: [...manager.menu],
  };

  switch (role) {
    case "banned":
      return generateRoutes(banned);
    case "usersFinexpert":
      return generateRoutes(users);
    case "managerFinexpert":
      return generateRoutes(manager);
    case "adminFinexpert":
      return generateRoutes(admin);
    default:
      return generateRoutes(banned);
  }
};
